import { buttonClasses, Card, EmptyState } from "@love-cpmd/ui";
import { Compass } from "lucide-react";
import { Link } from "react-router-dom";
import { PageContainer } from "../components/common/layout-bits";

export function NotFoundPage() {
  return (
    <PageContainer width="narrow">
      <Card>
        <EmptyState
          icon={<Compass />}
          title="Page not found"
          description="The link may be old or mistyped."
          action={
            <Link to="/dashboard" className={buttonClasses()}>
              Back to Dashboard
            </Link>
          }
        />
      </Card>
    </PageContainer>
  );
}
